import { list_agent_summaries, api_agent } from '@/api/agent';
import { CountryEnum, LanguageEnum, AgentTypeEnum } from '@/api/types';
import { formatDate, stringToIDate } from './index';

export const agentSummaryById = (
  agents: list_agent_summaries.AgentSummary[]
) => {
  return new Map(agents.map(a => [a.id, a]));
};

export const newDefaultAgent = () => {
  const today = new Date();
  const todayObj = stringToIDate(formatDate(today));
  return {
    id: '',
    name: '',
    alias: [],
    country: CountryEnum.UNIVERSAL,
    type: AgentTypeEnum.OVERSEAS_BUYOUT,
    // commissionRatePercent: 0,
    salesTarget: api_agent.SalesTargetEnum.CUSTOMER,
    contractProducts: [],
    orderAmountLimit: {},
    address: {
      countryCode: CountryEnum.UNIVERSAL,
      countryArea: '-',
      city: '-',
      postalCode: '-',
      streetAddress1: '-',
      streetAddress2: '-',
    },
    contacts: [
      {
        name: '-',
        department: '-',
        position: '-',
        phoneNumber: '00000000',
        faxNumber: '-',
        emailAddress: '',
      },
    ],
    contractSendDate: todayObj,
    contractReceiveDate: todayObj,
    contractDeliveryDate: todayObj,
    billingLanguage: LanguageEnum.ENGLISH,
    billingAddress: {
      countryCode: CountryEnum.UNIVERSAL,
      countryArea: '-',
      city: '-',
      postalCode: '-',
      streetAddress1: '-',
      streetAddress2: '-',
    },
    billingReceivers: [
      {
        name: '-',
        department: '-',
        position: '-',
        phoneNumber: '00000000',
        faxNumber: '-',
        emailAddress: '',
      },
    ],
    shippingLanguage: LanguageEnum.ENGLISH,
    shippingAddress: {
      countryCode: CountryEnum.UNIVERSAL,
      countryArea: '-',
      city: '-',
      postalCode: '-',
      streetAddress1: '-',
      streetAddress2: '-',
    },
    shippingReceivers: [
      {
        name: '-',
        department: '-',
        position: '-',
        phoneNumber: '00000000',
        faxNumber: '-',
        emailAddress: '',
      },
    ],
    remarks: '',
    gdsOtaId: '',
    agencyInvoiceCycleMonth: 0,
    gdsOtaUsername: '',
    gdsOtaPassword: '',
  } as api_agent.Agent;
};
